import { render } from "./GeneralAssemblyView.vue?vue&type=template&id=060339ec&scoped=true"
import script from "./GeneralAssemblyView.vue?vue&type=script&lang=js"
export * from "./GeneralAssemblyView.vue?vue&type=script&lang=js"

import "./GeneralAssemblyView.vue?vue&type=style&index=0&id=060339ec&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060339ec"]])

export default __exports__